import HundredBricksAPIError from '../../HundredBricksAPIError';
class RegisterFiscalRegimeError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('RegisterFiscalRegimeError', ...args);
    }
}
export default RegisterFiscalRegimeError;
